import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const applinksExtraAuthHealthcheckRoute: InvariantJiraRoute = {
	name: 'global-settings-products-applinks-extra-auth',
	path: '/jira/settings/applinks/extra-auth/healthcheck',
	exact: true,
};
